import { getCities } from '@/lib/data'
import CityLinks from '@/components/CityLinks'
import Head from 'next/head'
import Hero from '@/components/Hero'

export default function Cities({ cities }: { cities: any[] }) {
  return (
    <>
      <Head>
        <title>Alle Standorte | Autoverwertung Deutschland</title>
        <meta name="description" content="Finden Sie unseren Autoverwertung und KFZ-Ankauf Service in über 70 Städten in Deutschland. Professionelle Fahrzeugentsorgung und faire Preise." />
        <meta property="og:title" content="Alle Standorte | Autoverwertung Deutschland" />
        <meta property="og:description" content="Finden Sie unseren Autoverwertung und KFZ-Ankauf Service in über 70 Städten in Deutschland. Professionelle Fahrzeugentsorgung und faire Preise." />
        <meta property="og:image" content="/images/cars/reccar.webp" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://autoverwertungs.de/cities" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Alle Standorte | Autoverwertung Deutschland" />
        <meta name="twitter:description" content="Finden Sie unseren Autoverwertung und KFZ-Ankauf Service in über 70 Städten in Deutschland. Professionelle Fahrzeugentsorgung und faire Preise." />
        <meta name="twitter:image" content="/logo.jpeg" />
        <meta name="robots" content="index, follow" />
      </Head>
    <Hero city={""} />
      <div className="container mx-auto px-4 py-8 md:py-12 lg:py-16">
        <div className="text-center mb-8 md:mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            Alle unsere Standorte
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Wir bieten professionelle Autoverwertung und KFZ-Ankauf in über 70 Städten in Deutschland.
            Finden Sie Ihren nächstgelegenen Standort für faire Preise und umweltgerechte Fahrzeugentsorgung.
          </p>
        </div>

        <CityLinks cities={cities} showAll={true} />
      </div>
    </>
  )
}

export async function getStaticProps() {
  const cities = await getCities()
  return { props: { cities } }
}